import { render } from "./AddDivision.vue?vue&type=template&id=377c1a75"
import script from "./AddDivision.vue?vue&type=script&lang=js"
export * from "./AddDivision.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__